/*!
 * KanbanView - Vue tableau Kanban par colonnes / étapes avec Drag & Drop pour IconsView
 */

import CardView from './CardView';

export default class KanbanView extends CardView {
    constructor(plugin) {
        super(plugin, 'kanban');
        this.columnsMap = new Map();
        this.groupField = null;
    }

    /**
     * Récupère le champ de regroupement (status, stage, group, etc.)
     * @returns {String}
     */
    getGroupField() {
        const myself = this.plugin;
        if (myself.template && myself.template.view && myself.template.view.kanban && myself.template.view.kanban.field) {
            return myself.template.view.kanban.field;
        }
        if (myself.options && myself.options.kanbanField) {
            return myself.options.kanbanField;
        }
        return 'status';
    }

    /**
     * Récupère les colonnes prédéfinies si configurées
     * @returns {Array|null}
     */
    getPredefinedColumns() {
        const myself = this.plugin;
        const conf = myself.template && myself.template.view && myself.template.view.kanban;
        if (conf && conf.columns) {
            if (Array.isArray(conf.columns)) {
                return conf.columns;
            }
            if (typeof conf.columns === 'object') {
                return Object.keys(conf.columns).map((key) => {
                    const col = conf.columns[key];
                    return typeof col === 'object'
                        ? { key, label: col.label || key, color: col.color, icon: col.icon }
                        : { key, label: col };
                });
            }
        }
        return null;
    }

    createContainer(element) {
        const myself = this.plugin;
        this.columnsMap.clear();
        this.groupField = this.getGroupField();

        this.container = $('<div class="iv__kanban-board"></div>');
        myself.container = this.container;

        myself.containerView.addClass('iv__view iv__view--kanban view view-kanban');
        element.append(this.container);

        // Création des colonnes prédéfinies
        const predefined = this.getPredefinedColumns();
        if (predefined && predefined.length) {
            predefined.forEach((colDef) => {
                this.getOrCreateColumn(colDef.key, colDef);
            });
        }

        if (myself.preview) {
            element.append(myself.preview);
        }

        return this.container;
    }

    /**
     * Obtient ou crée une colonne Kanban par sa clé
     * @param {String} key
     * @param {Object} [meta]
     * @returns {jQuery}
     */
    getOrCreateColumn(key, meta = {}) {
        const myself = this.plugin;
        const normalizedKey = (key !== undefined && key !== null && key !== '') ? String(key) : '__unassigned__';

        if (this.columnsMap.has(normalizedKey)) {
            return this.columnsMap.get(normalizedKey);
        }

        const label = meta.label || (normalizedKey === '__unassigned__' ? __('Non classé') : normalizedKey);
        const color = meta.color || '';
        const colorStyle = color ? 'border-top-color: ' + color + ';' : '';

        const $col = $(`
            <div class="iv__kanban-col" data-col-key="${normalizedKey}" style="${colorStyle}">
                <div class="iv__kanban-col__header">
                    <div class="iv__kanban-col__title-wrap">
                        ${color ? '<span class="iv__kanban-col__dot" style="background-color: ' + color + ';"></span>' : ''}
                        <span class="iv__kanban-col__title">${label}</span>
                    </div>
                    <span class="iv__kanban-col__count badge">0</span>
                </div>
                <div class="iv__kanban-col__cards iv__container"></div>
            </div>
        `);

        // Gestion du drop sur la colonne
        const $cardsContainer = $col.find('.iv__kanban-col__cards');
        this.bindColumnDropZone($col, $cardsContainer, normalizedKey);

        this.container.append($col);
        this.columnsMap.set(normalizedKey, $col);
        return $col;
    }

    /**
     * Lie les événements Drag & Drop sur une colonne Kanban
     * @param {jQuery} $col
     * @param {jQuery} $cardsContainer
     * @param {String} colKey
     */
    bindColumnDropZone($col, $cardsContainer, colKey) {
        const myself = this.plugin;
        const groupField = this.groupField;

        $cardsContainer.on('dragover', (e) => {
            e.preventDefault();
            e.originalEvent.dataTransfer.dropEffect = 'move';
            $col.addClass('iv__kanban-col--dragover');
        });

        $cardsContainer.on('dragleave', (e) => {
            if (!$col[0].contains(e.relatedTarget)) {
                $col.removeClass('iv__kanban-col--dragover');
            }
        });

        $cardsContainer.on('drop', (e) => {
            e.preventDefault();
            $col.removeClass('iv__kanban-col--dragover');

            const itemId = e.originalEvent.dataTransfer.getData('text/plain');
            if (!itemId) return;

            const $card = myself.element.find(`.iv__item--${itemId}`);
            if (!$card.length) return;

            const itemData = $card.data('data');
            if (!itemData) return;

            const currentVal = (itemData.data && itemData.data[groupField] !== undefined)
                ? itemData.data[groupField]
                : itemData[groupField];

            const targetVal = (colKey === '__unassigned__') ? '' : colKey;

            if (String(currentVal) !== String(targetVal)) {
                // Déplacement visuel immédiat
                $cardsContainer.append($card);

                // Mise à jour de la donnée locale
                if (itemData.data) itemData.data[groupField] = targetVal;
                itemData[groupField] = targetVal;

                // Soumission serveur
                const queryData = {};
                queryData[groupField] = targetVal;
                myself.submitChange(itemData, queryData);

                // Recalcul des compteurs des colonnes
                this.updateAllColCounts();
            }
        });
    }

    /**
     * Met à jour le compteur d'éléments de chaque colonne
     */
    updateAllColCounts() {
        this.columnsMap.forEach(($col) => {
            const count = $col.find('.iv__kanban-col__cards > .iv__item').length;
            $col.find('.iv__kanban-col__count').text(count);
        });
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        myself.viewItemThumbsMode = false;
        const groupField = this.groupField || this.getGroupField();

        // Récupération de la clé de colonne
        let itemColKey = '';
        if (data.data && data.data[groupField] !== undefined && data.data[groupField] !== null) {
            itemColKey = data.data[groupField];
        } else if (data[groupField] !== undefined && data[groupField] !== null) {
            itemColKey = data[groupField];
        }

        const $col = this.getOrCreateColumn(itemColKey);
        const $targetCards = $col.find('.iv__kanban-col__cards');

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const kanbanFields = myself.getViewFields('kanban') || myself.getViewFields('mosaic');
        const codeSubtext = this.buildFieldsSubtext(data, kanbanFields);

        const kanbanIconSize = myself.getViewIconSize('kanban') || 40;
        myself.viewThumbsHeight = kanbanIconSize;
        myself.viewThumbsWidth = kanbanIconSize;

        let countHtml = '';
        if (myself.shouldShowCount(data, 'kanban')) {
            countHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        const code = `
            <div class="${currentClassAll}" draggable="true">
                <div class="iv__item__frame">
                    <span class="iv__item__link">
                        <span class="iv__item__image">${myself.renderIconImage(kanbanIconSize, data.icon, data, 'img')}</span>
                        <label class="iv__item__label">
                            <span class="iv__item__name titre">${data.label || ''}</span>
                            ${countHtml}
                            ${codeSubtext.length > 0 ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : ''}
                        </label>
                    </span>
                </div>
            </div>
        `;

        const currentIcon = $(code);

        // Événement dragstart pour transporter l'ID
        currentIcon.on('dragstart', (e) => {
            currentIcon.addClass('iv__item--dragging');
            e.originalEvent.dataTransfer.setData('text/plain', String(data.id));
            e.originalEvent.dataTransfer.effectAllowed = 'move';
        });

        currentIcon.on('dragend', () => {
            currentIcon.removeClass('iv__item--dragging');
        });

        $targetCards.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIcon, data, currentType, path);
        this.renderBadge(data, currentIcon);

        // Mise à jour du compteur de la colonne
        const currentCount = $targetCards.children('.iv__item').length;
        $col.find('.iv__kanban-col__count').text(currentCount);

        return currentIcon;
    }

    getZoomLimits() {
        return { enabled: true, min: 24, max: 64 };
    }
}
